export const protobufPackage = "snapchat.snapdoc";
export enum VideoFileFormat {
    VIDEO_FILE_FORMAT_UNSET = 0,
    MP4 = 1,
    FMP4 = 2,
    UNRECOGNIZED = -1
}
